import { OptionDto } from "@/dtos";
import { RouteOrientationType } from "@/helpers/types";

const orientations = [
    { value: RouteOrientationType.ONE_WAY, label: 'IDA' },
    { value: RouteOrientationType.RETURN, label: 'VUELTA'},
    { value: RouteOrientationType.CIRCULAR, label: 'CIRCULAR'},
] as OptionDto[];

export const getRouteOrientationOptions = (): OptionDto[] => {
    return orientations;
}

export const getRouteOrientationOption = (value?: number): OptionDto => {
    return orientations.find((x) => x.value == value) ?? orientations[0];
}

export const getRouteOrientationLabel = (value: number): string => {
    return orientations.find((x) => x.value == value)?.label ?? orientations[0].label;
}
